/* eslint-disable no-undef */
import request from '@/utils/request'
export function login(data) {
  return request({
    url: '/api/sso/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/api/sso/getRoles',
    method: 'get',
    params: { token }
  })
}
// 退出登录，
export function logout(token) {
  return request({
    url: '/api/sso/loginout',
    method: 'post',
      params: { token }
  })

}
// 获取用户地址打日志报告
export function loginip(data) {
  return request({
    url: '/api/org/loginlog/add',
    method: 'post',
    data,
    baseURL: VUE_APP_BASE_API
  })
}
